import * as Yup from "yup";
import {
  emailValidationRegex,
  faxNumberRegex,
  websiteUrlRegex,
  zipCodeRegex,
} from "../../../../../../constants/regexStrings";
import phoneValidation from "../../../../../../common/components/phone-number-input-component/phone-validation";
import { isOnlyCountryCode } from "../../../../../../utils/utils";

export const validationSchema = (isEditMode: boolean) =>
  Yup.object().shape({
    title: Yup.string().max(50, "Title cannot be more than 50 characters"),
    firstName: Yup.string()
      .required("First Name cannot be empty")
      .matches(
        /^[A-Za-z -]+$/,
        "First Name can only contain letters, spaces, and hyphens"
      ),
    leadValue: Yup.string()
      .matches(/^\d+(\.\d+)?$/, "lead value format is invalid")
      .max(15, "Lead value cannot be more than 15 characters")
      .nullable(),
    lastName: Yup.string()
      .required("Last Name cannot be empty")
      .matches(
        /^[A-Za-z -]+$/,
        "Last Name can only contain letters, spaces, and hyphens"
      ),
    middleName: Yup.string()
      .nullable()
      .matches(
        /^[A-Za-z -]+$/,
        "Middle Name can only contain letters, spaces, and hyphens"
      ),
    email: Yup.string()
      .matches(emailValidationRegex, "Please enter a valid Email address")
      .required("Email cannot be empty")
      .max(150, "Email cannot be more than 150 characters"),
    primaryPhoneNumber: Yup.string()
      .test(
        "is-valid-phone",
        "Please enter a valid phone number",
        function (value: any) {
          if (isOnlyCountryCode(value)) {
            return true;
          }
          return phoneValidation(value);
        }
      )
      .nullable(),

    streetLine1: Yup.string()
      .nullable()
      .min(3, "Street line 1 must be at least 3 characters")
      .max(100, "Street line 1 cannot be more than 100 characters"),
    streetLine2: Yup.string()
      .nullable()
      .min(3, "Street line 2 must be at least 3 characters")
      .max(100, "Street line 2 cannot be more than 100 characters"),
    city: Yup.string()
      .max(100, "City name cannot be more than 100 characters")
      .nullable(),

    state: Yup.string()
      .max(100, "State name cannot be more than 100 characters")
      .nullable(),
    country: Yup.string()
      .max(100, "Country name cannot be more than 100 characters")
      .nullable(),
    zipcode: Yup.string().matches(zipCodeRegex, "Invalid Zipcode").nullable(),
    description: Yup.string()
      .max(150, "Description cannot be more than 150 characters")
      .nullable(),
  });
